{
  "brand": "Aruba Animal Radar",
  "tagline": "Street animal case files — sightings, lost pets, chips.",
  "nav": {
    "map": "Map",
    "addSighting": "Add sighting",
    "reportLost": "Report lost",
    "searchChip": "Search chip",
    "login": "Sign in",
    "logout": "Sign out"
  },
  "panel": {
    "title": "Active cases",
    "lostTitle": "Currently lost",
    "emptyLost": "No active lost reports.",
    "openPanel": "Case files",
    "closePanel": "Close",
    "sightings": "Sightings",
    "related": "Linked sightings",
    "stepPrev": "Previous sighting",
    "stepNext": "Next sighting"
  },
  "fields": {
    "type": "Type",
    "breed": "Breed",
    "color1": "Primary color",
    "color2": "Secondary color",
    "color3": "Third color",
    "chip": "Microchip",
    "spayed": "Spayed / Neutered",
    "ownership": "Ownership status",
    "ifFound": "If found, contact",
    "notes": "Notes",
    "location": "Location",
    "sightedAt": "Sighted at",
    "contact": "Contact information",
    "unknown": "Unknown",
    "none": "None",
    "other": "Other"
  },
  "types": {
    "dog": "Dog",
    "cat": "Cat",
    "other": "Other"
  },
  "colors": {
    "black": "Black",
    "white": "White",
    "brown_chocolate": "Brown / Chocolate",
    "tan_fawn": "Tan / Fawn",
    "red_orange": "Red / Orange",
    "gray_blue": "Gray / Blue",
    "cream_yellow": "Cream / Yellow",
    "gold_apricot": "Gold / Apricot"
  },
  "ownership": {
    "confirmed_owned": "Confirmed owned",
    "confirmed_abandoned": "Confirmed abandoned",
    "no_known_owner": "No known owner",
    "reported_lost": "Reported lost"
  },
  "spayed": {
    "yes": "Yes",
    "no": "No",
    "unknown": "Unknown"
  },
  "actions": {
    "submit": "Submit",
    "cancel": "Cancel",
    "search": "Search",
    "link": "Link sightings",
    "unlink": "Unlink from animal",
    "save": "Save",
    "pickOnMap": "Pick on map"
  },
  "forms": {
    "addSightingTitle": "Log a sighting",
    "reportLostTitle": "Report a lost pet",
    "chipSearchTitle": "Chip search",
    "chipPlaceholder": "Enter microchip number",
    "breedOtherHint": "Custom breeds can be added when reporting a lost pet.",
    "noResults": "No matches found."
  },
  "lang": {
    "label": "Language",
    "en": "English",
    "es": "Español",
    "pap": "Papiamento",
    "nl": "Nederlands"
  },
  "status": {
    "loading": "Loading…",
    "mapLoading": "Initializing map…",
    "error": "Something went wrong."
  }
}
